import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { profileApi, queryClient } from '~/lib/request';

function useHeroPointSwitch() {
  return useMutation<unknown, Error, string>({
    mutationFn: (data) =>
      profileApi.post('api/profile/me/heropoints', {
        json: { hero_points: data },
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['currentUser'] });

      toast.success('Data updated successfully!');
    },
  });
}

export default useHeroPointSwitch;
